module.exports = __webpack_public_path__ + "media/audio19.bd8e67ce.mp3";